
import * as React from "react";
import { useState } from "react";
// import Box from "@mui/material/Box";
// import Carousel from "@mui/material/Carousel";
// import { autoplayPlugin } from "@mui/lab";

import { Box } from "@mui/system";

import Carousel from "react-material-ui-carousel";

import PlatformKitchenBanner from "../assets/ScrollingBannerImages/PlatformKitchenBanner.webp";
import ConveyerBanner from "../assets/ScrollingBannerImages/ConveyerBanner.webp";
import IotAutomation from "../assets/ScrollingBannerImages/IotAutomation.webp";
import ClientsBanner from "../assets/ScrollingBannerImages/ClientsBanner.webp";


const images = [PlatformKitchenBanner, ClientsBanner, ConveyerBanner, IotAutomation];

function SlidingImage() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSlideChange = (index) => {
    setCurrentIndex(index);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center", // Centers horizontally
        alignItems: "center",     // Centers vertically
        width: "100vw",           // Full viewport width
        overflow: "hidden",       // Prevent overflow of images
      }}
    >
      <Carousel
        activeIndex={currentIndex}
        onChange={handleSlideChange}
        autoPlay
        animation="slide"
        sx={{
          height: "80%",
          width: "80%",
          padding: "30px"
        }}
      >
        {images.map((image, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%"
            }}
          >
            <img
              src={image}
              alt={`Slide ${index}`}
              style={{
                maxHeight: "100%",
                maxWidth: "100%",
                objectFit: "contain" // Or 'cover' based on your preference
              }}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  );
}

export default SlidingImage;